
<template>

	<elements
		ref="elements"
		service="cadastral_objects"
		without_add
		without_back_button
		:attrs="attrs"
		:get_many_extra="{ group : id }"
		not_able_for_delete
		emit_on_double_click_element
		essence_name_genetive_case="объекта"
		essence_name_for_plural_1="объект"
		essence_name_for_plural_234="объекта"
		essence_name_for_plural_others="объектов"
		:elements_table_height="elements_table_height"
		:postfix_for_storage_name="`details_comparative_${id}`"
		with_message_on_empty_get_many
	>
	
		<template v-slot:title><h4>Детализация</h4></template>

	</elements>

</template>

<script>

import api from "../../../../../api"
import elements from "../../../../elements"

export default
{
	props :
	{
		id : String,
		cost_evaluation : Object,
	},

	components :
	{
		elements,
	},

	data()
	{
		var attrs =
			[
				{
					attr_key : "attrs.CadastralNumber",
					visible : true,
					visible_if_no_visible : true,
					is_cadastral_number : true,
				},
				{
					attr_key : "attrs.Area",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					attr_key : "attrs.cost_comparative",
					visible : true,
					visible_if_no_visible : true,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				},
				{
					attr_key : "attrs.UPKS_comparative",
					visible : true,
					visible_if_no_visible : true,
					my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
				},
			]

		this.cost_evaluation.attrs.forEach(
			attr =>
			{
				var reference = null

				if(attrs.findIndex(_attr => _attr.attr_key == attr.key) >= 0)
					return

				if(attr.reference != null)
				{
					reference = []

					attr.reference.values.forEach(value => reference.push({ label : api.format_reference(attr.reference, value), value : value }))
				}

				attrs.push(
				{
					key : "current_version." + attr.key,
					label : attr.name,
					sortable : true,
					visible : false,
					in_query : true,
					type : attr.type,
					reference : { simple_values : reference },
				})
			})

		return {

			elements_table_height : "100%",
			attrs : attrs,

		}
	},

	methods :
	{
		refresh()
		{
			this.$refs.elements.refresh()
		},
	}
}

</script>

